<app-status-page [fullPage]="true" kind="server-error" code="Error 500"
                 title="Smart TOS ran into a problem"
                 message="Something went wrong on our side, not with anything you did. Try again in a moment; if it keeps happening, contact your terminal administrator.">
  <button type="button" class="btn secondary_button" (click)="goToHome()">Go to Smart TOS</button>
  <button type="button" class="btn primary_button" (click)="tryAgain()">Try again</button>
</app-status-page>
